export default "__VITE_PUBLIC_ASSET__3bf8b165__"